import React, { ReactNode, Fragment } from "react";
import { HeadFC, Script } from "gatsby";
import { queryResult } from "../data/graphql/query";
import { getGatsbyImageNode } from "../../utils/getGatsbyImageNode";

import LayoutLibrary from "@flyvet/flyvet-react-library/dist/src/containers/layouts/layout-with-alert-24h";
import ClientAreaButton from "@flyvet/flyvet-react-library/dist/src/components/buttons/client-area-button";

import "../styles/variables.scss";

export type LayoutProps = {
  children: ReactNode;
};


export const Layout = ({ children }: any) => {
  const {
    companyName,
    city,
    logoTopbar,
    logoFooter,
    GA4,
    facebook,
    instagram,
    linkedin,
    landingSubtitle,
  } = queryResult();

    const renderButton24h = (trackEvent: any) => (
    <div style={{ padding: 8 }}>
      <ClientAreaButton
        eventCategory="click_ligar"
        clickEventName="click_plantao"
        onClick={() => trackEvent({ action: "click_plantao" })}
        containerLabel="topbar-button"
        btnLabelTop="Entre em contato"
        btnLabelBottom="(61) 99126-6426"
        clientArealink="tel:+5561991266426"
      ></ClientAreaButton>
    </div>
      );

  return (
    <Fragment>
      {/* <Script
        src={`https://www.googletagmanager.com/gtag/js?id=${GA4}`}
        strategy="off-main-thread"
        forward={[`gtag`]}
      />
      <Script
        id="gtag-config"
        strategy="off-main-thread"
        dangerouslySetInnerHTML={{
          __html: `window.dataLayer = window.dataLayer || [];
          window.gtag = function gtag(){ window.dataLayer.push(arguments);}
          gtag('js', new Date()); 
          gtag('config', '${GA4}', { send_page_view: false })`,
        }}
      /> */}

      <LayoutLibrary
        logoTopbar={getGatsbyImageNode(
          logoTopbar,
          `Logo ${companyName}`,
          true,
          false,
          false
        )}
        logoFooter={getGatsbyImageNode(
          logoFooter,
          `Logo ${companyName}`,
          true,
          true,
          true
        )}
        renderButton24h={renderButton24h} 
        alertText="Entre em Contato"
        phone="5561991266426"
        phoneAlertText="(61) 99126-6426"
        companyName={companyName}
        city={city}
        slogan="Cuidando do seu pet com todo carinho e respeito que ele merece!"
        badge={{ type: "vet" }}
        facebook={facebook}
        instagram={instagram.user}
        linkedin={linkedin}
        navItems={[
          {
            label: "Home",
            path: "/",
          },
          {
            label: "Serviços",
            path: "/servicos",
          },
          {
            label: "Contato",
            path: "/contato",
          },
          {
            label: "Conheça nossa Estrutura",
            path: "https://www.google.com/local/place/fid/0x935a337e1d828637:0x46983d83d7bcbeec/photosphere?iu=https://lh3.googleusercontent.com/gps-cs-s/AC9h4nq0UREDydMHLFwi-BN7Xo4_L0Ufc-fQiFjTzpYlm3Ms1SAf8ySwidHn2HC7shKYtYRR5mRILx9aG5s3TINXcEBzvuWtiH_n6Z0pqY1zcxFliSzl8SeRJl7VjuiWG0zUrvaE3SD8%3Dw160-h106-k-no-pi0-ya358.1361-ro-0-fo100&ik=CAoSF0NJSE0wb2dLRUlDQWdJRFZ6NE9IX3dF",
          },
        ]}
      >
        {children}
      </LayoutLibrary>
    </Fragment>
  );
};

export default Layout;

export const Head: HeadFC<{}> = ({ }) => (
  <>
    <link
      key="nunito"
      rel="preload"
      href="/src/styles/fonts/nunito-v26-latin-regular.woff2"
      as="font"
      type="font/woff2"
      crossOrigin="anonymous"
    />
    ,
    <link
      key="titillium-web"
      rel="preload"
      href="/src/styles/fonts/titillium-web-v17-latin-regular.woff2"
      as="font"
      type="font/woff2"
      crossOrigin="anonymous"
    />
    ,
  </>
);
